// extracted by mini-css-extract-plugin
export default {"wrapper":"search-input-module--wrapper--f8403","icon":"search-input-module--icon--89410","error":"search-input-module--error--44696","input":"search-input-module--input--e2315"};